const Layout = () => import("../components/layout/layout");
const HomeInstitution = () => import("../components/institution/easyFindMe");
const Imagenology = () => import("../components/imagenology/imagenology");
const pdfView = () => import("../components/imagenology/pdfViewComponent");
const Laboratory = () => import("../components/laboratory/laboratory");
const resultLaboratory = () =>
  import("../components/laboratory/resultLaboratory");
const myHealthCenter = () => import("../components/institution/myHealthCenter");
const healthCenters = () => import("../components/institution/healthCenters");
const myProfessional = () =>
  import("../components/professional/myHealthCareProfessional");
const professionals = () =>
  import("../components/professional/healthCareProfessionals");
const myPatient = () => import("../components/patient/myPatient");
const medicalMeasurements = () =>
  import("../components/laboratory/medicalMeasurements");
const notifications = () => import("../components/notifications/notifications");
const easyfindme = () => import("../components/easyfindme/easyFindMe");
const easyFindMePatient = () =>
  import("../components/easyfindme/easyFindMePatient");
const easyFindMeComplete = () =>
  import("../components/easyfindme/easyFindMeComplete");
const appoinment = () => import("../components/appoinment/appoinment");
const videoconsulta = () => import("../components/videoconsulta/videoconsulta");
// const profilePatient = () => import ('../components/patient/profilePatient')
const dataProfilePatient = () =>
  import("../components/easyfindme/patient/dataProfilePatient");
const message = () => import("../components/message/message");
const measurements = () => import("../components/measurements/measurements");
const dataPersonalConsultation = () =>
  import("../components/consultation/dataPersonal");
const dataAntecedentsConsultation = () =>
  import("../components/consultation/antecedents");
const dataConsultation = () =>
  import("../components/consultation/consultation");
const dataDiagnosticsConsultation = () =>
  import("../components/consultation/diagnostic");
const dataParaclinicsConsultation = () =>
  import("../components/consultation/paraclinics");
const dashboardPatient = () =>
  import("../components/dashboard/dashboardPatient");
const dashboardProfessional = () =>
  import("../components/dashboard/dashboardProfessional");
const dashboard = () => import("../components/dashboard/dashboard");
// const inmunization = () => import("../components/inmunizations/inmunization");
const consultations_history = () =>
  import("../components/consultation/consultations-history");
const prescription = () => import("../components/prescription/prescription");
const prescriptionPatient = () =>
  import("../components/prescription/patient/prescriptionPatient");
const myaccount = () => import("../components/myaccount/myaccount.vue");
const password = () => import("../components/myaccount/password");
const plan = () => import("../components/myaccount/plan");
const info_bank = () => import("../components/myaccount/info-bank");
const exams = () => import("../components/exams/exams");
const exams_history = () => import("../components/exams/exams-history");
// const settingDoctorOnline = () =>
//   import("../components/myaccount/settingDoctorOnline");
const idioms = () => import("../components/myaccount/idioms");
const appointConfig = () => import("../components/appoinment/configAppointmentPrincipal");
const appointment = () => import("../components/appoinmentCalendar/appointmentCalendar");
const dashboardAux = () => import("../components/dashboard/dashboardAux");
const redirectProfile = () => import("../components/patient/redirectProfile");
const customized_settings = () => import("../components/costomized_settings/settings.vue");

export default [{
  path: "/profile/:role",
  component: Layout,
  children: [{
      path: "/",
      name: "homeinstitution",
      component: easyFindMeComplete
    },
    {
      path: "imagenology",
      name: "imagenology",
      component: Imagenology
    },
    {
      path: "laboratory",
      name: "laboratory",
      component: Laboratory
    },
    {
      path: "result-laboratory",
      name: "resultLaboratory",
      component: resultLaboratory,
      props: true
    },
    {
      path: "healthcenter",
      name: "healthcenter",
      component: healthCenters,
      props: true
    },
    {
      path: "myHealthCenter",
      name: "myHealthCenter",
      component: myHealthCenter
    },
    {
      path: "professionals",
      name: "professionals",
      component: professionals,
      props: true
    },
    {
      path: "myProfessional",
      name: "myProfessional",
      component: myProfessional
    },
    {
      path: "patient",
      name: "patient",
      component: myPatient,
      props: true
    },
    {
      path: "graphic",
      name: "medicalMeasurements",
      props: true,
      component: medicalMeasurements
    },
    {
      path: "notifications",
      name: "notifications",
      component: notifications
    },
    {
      path: "easyfindme",
      name: "easyfindme",
      component: easyFindMeComplete
    },
    {
      path: "easyFindMePatient",
      component: easyFindMePatient
    },
    {
      path: "appoinment",
      component: appoinment
    },
    {
      path: "videoconsulta",
      name: "videoconsulta",
      component: videoconsulta
    },
    {
      path: "prescriptionPatient",
      name: "prescriptionPatient",
      component: prescriptionPatient
    },
    {
      path: "pdfView",
      name: "pdfView",
      component: pdfView
    },
    /*         {
          path : 'dataProfilePatient',
          component : dataProfilePatient
      }, */
    {
      path: "message",
      name: "message",
      component: message
    },
    {
      path: "measurements",
      name: "measurements",
      component: measurements
    },
    {
      path: "dataPersonalConsultation",
      name: "dataPersonalConsultation",
      component: dataPersonalConsultation
    },
    {
      path: "dataAntecedentsConsultation",
      name: "dataAntecedentsConsultation",
      component: dataAntecedentsConsultation
    },
    {
      path: "dataConsultation",
      name: "dataConsultation",
      component: dataConsultation
    },
    {
      path: "dataDiagnosticsConsultation",
      name: "dataDiagnosticsConsultation",
      component: dataDiagnosticsConsultation
    },
    {
      path: "dataParaclinicsConsultation",
      name: "dataParaclinicsConsultation",
      component: dataParaclinicsConsultation
    },
    {
      path: "dashboardPatient",
      name: "dashboardPatient",
      component: dashboardPatient
    },
    {
      path: "dashboardProfessional",
      name: "dashboardProfesisonal",
      component: dashboardProfessional
    },
    {
      path: "dashboard",
      name: "dashboard",
      component: dashboard
    },
    // {
    //   path: "inmunization",
    //   name: "inmunization",
    //   component: inmunization
    // },
    {
      path: "record",
      name: "consultations-history",
      component: consultations_history
    },
    {
      path: "exams",
      name: "exams",
      component: exams
    },
    {
      path: "exams-history",
      name: "exams-history",
      props: true,
      component: exams_history
    },
    {
      path: "prescription",
      name: "prescription",
      component: prescription
    },
    {
      path: "myaccount",
      name: "myaccount",
      component: myaccount
    },
    {
      path: "password",
      name: "password",
      component: password
    },
    {
      path: "plan",
      name: "plan",
      component: plan
    },
    {
      path: "info-bank",
      name: "info-bank",
      component: info_bank
    },
    // {
    //   path: "settingDoctorOnline",
    //   name: "settingDoctorOnline",
    //   component: settingDoctorOnline
    // },
    {
      path: "idioms",
      name: "idioms",
      component: idioms
    },
    {
      path: "appointConfig",
      name: "appointConfig",
      component: appointConfig,
      props: true
    },
    {
      path: "appointment",
      name: "appointment",
      component: appointment
    },
    {
      path: "dashboardAux",
      name: "dashboardAux",
      component: dashboardAux
    },
    {
      path: "redirect/patient/:idUser?",
      name: "redirect",
      component: redirectProfile
    },
    {
      path: "customized/settings",
      name: "customized_settings",      
      component: customized_settings
    }
  ],
  props: true,
  meta: {
    requiresAuth: true
  }
}];



// WEBPACK FOOTER //
// ./src/router/layout.js